// Declare gtag as a global function (loaded in index.html)
declare function gtag(...args: unknown[]): void;

/**
 * Fire the Google Ads conversion for PPC landing page form submissions.
 * Conversion: AW-11071702370 / NCc0CKDb1cIbEOKKs58p
 */
export function trackAdsConversion() {
  if (typeof gtag !== "undefined") {
    gtag("event", "conversion", {
      send_to: "AW-11071702370/NCc0CKDb1cIbEOKKs58p",
    });
  }
}
